import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import { PublicAccordion } from 'Components/Public/Accordion/PublicAccordion';
import { getFileTypeIcon, ICONS } from 'Utils/icons';
import { Dropdown, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { IconTextButton, TextButton } from 'Components/Button';
import { DatasetOutlined, HelpOutlineOutlined, LocalHospitalOutlined, ManageAccountsOutlined, PersonalInjuryOutlined, QuestionAnswerOutlined, SearchOutlined } from '@mui/icons-material';
import Form from 'react-bootstrap/Form';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
import { useNavigate, useLocation } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';
import { useDispatch } from 'react-redux';
import { store } from 'Store';
import { http } from 'Utils';
import { ERROR_MESSAGES } from 'Utils/constants';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import parse from 'html-react-parser';
import DatatablePagination from 'Components/Datatable/DatatablePagination';
import { handleFileDownload } from 'Utils/utilityFunctions';
import InfiniteScroll from 'react-infinite-scroll-component';
import DownloadLink from 'Components/Public/DownloadLink/DownloadLink';
import { ga_log_search } from 'Utils/GA4/GTM';
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";

//DOWNLOAD
function Search () {

    let location = useLocation();
    var passedData = location.state;
    const dispatch = useDispatch();
    const navigate = useNavigate();


    //const [searchTerm, setSearchTerm] = useState(null);
    const [resultTerm, setResultTerm] = useState(null);
    const [exactMatchFlag, setExactMatchFlag] = useState(true);
    // maintain current search exact match flag
    const [curExactMatchFlag, setCurExactMatchFlag] = useState(true);

    const [showSearchResults, setShowSearchResults] = useState(false);
    //const [showDropdown, setShowDropdown] = useState(false);
    //const [displayDrop, setDisplayDrop] = useState(true);

    //const [listData, setListData] = useState(null);


    const [resultsData, setResultsData] = useState(null);
    //const [highlightData, setHighlightData] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsTotal, setRecordsTotal] = useState(0);
    const [rangeStart, setRangeStart] = useState(0);
    const [rangeEnd, setRangeEnd] = useState(10);

    const [downloadingFiles, setDownloadingFiles] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const dropdownRef = useRef(null);
    const formRef = useRef(null);
    //const childRef = useRef(null);

    // Tooltip for Exact Match Overlay
    const renderTooltip = (props) => (
        <Tooltip id="exactMatchTooltip" {...props} className='exact-match-tooltip'>
            By checking this box, you ensure that we won't perform partial matches against the text,
            allowing you to define your search more precisely.
        </Tooltip>
    );

    // Exact Match Overlay Component
    const ExactMatchOverLay = () => {
        return (
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
                trigger={["click", "hover", "focus"]}
            >
                <HelpOutlineOutlined style={{ color: "white" }} tabIndex={0}></HelpOutlineOutlined>
            </OverlayTrigger>
        );
    }

    useEffect(() => {
        //console.log(currentPage);

    }, [currentPage])

    useEffect(() => {
        //console.log(resultTerm);
        setRangeEnd(10);

    }, [resultTerm])

    const downloadFile = (groupId) => {
        //console.log(downloadingFiles);
        if (downloadingFiles.includes(groupId)) {

        }
        else {
            setDownloadingFiles([...downloadingFiles, groupId]);
            handleFileDownload(
                groupId,
                () => {
                    //console.log(document.activeElement);
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    })
                },
                () => {
                    setDownloadingFiles(downloadingFiles.filter(f => f == groupId))
                }
            );
        }

    }

    useEffect(() => {
        setRangeEnd(10);
        //console.log(passedData);
        //console.log(passedData.searchText);
        if (passedData != null) {
            if (passedData.hasOwnProperty('searchText') && passedData.searchText != null && passedData.searchText.trim() != '') {
                setResultTerm(passedData.searchText.trim());
                //setShowSearchResults(true);
                if (passedData.searchText != null && passedData.searchText.trim() != '') {
                    getSearchData(passedData.searchText.trim(), true, 10, exactMatchFlag).then((res) => {
                        /*//console.log(res);
                        setShowSearchResults(true);
                        setShowDropdown(false);
                        
                        setResultTerm(searchTerm);
                        setResultsData(listData);*/
                        location.state.searchTerm = null;
                        location.state.searchText = null;
                    });
                }
                else {

                }
            }
            else {
                setResultTerm(null);
            }

        }
    }, [])
    //let currentController = null;

    const getSearchData = async (search, fromSearchBar, end, exactMatchFlag) => {
        setIsLoading(true);
        setCurExactMatchFlag(exactMatchFlag);
        // If there's an ongoing request, cancel it
        //if (currentController) {
        //    currentController.abort();
        //}

        // Create a new AbortController for the new request
        //currentController = new AbortController();

        var url = '/api/search/';

        const loginState = store.getState().loginInfo;

        var data = {
            searchTerm: search,
            start: 0,//start!=null ? start : rangeStart,
            rows: end != null ? end : rangeEnd,//5
            exactMatch: exactMatchFlag
        }

        if (search == null || search == "" || search.trim() == '\"') {

            if (search != null) {
                setShowSearchResults(true);
                setResultsData(null);
                //setShowDropdown(false);

                setResultTerm(search);
                setRecordsTotal(0);
                setRangeEnd(0);
                setIsLoading(false);
            }
            else {
                setShowSearchResults(false);
                setResultsData(null);
                //setShowDropdown(false);

                setResultTerm(search);
                setRecordsTotal(0);
                setRangeEnd(0);
                setIsLoading(false);
            }

        }
        else {
            const res = http.post(url, data, {
                timeout: 65000, // Set a timeout of 5 seconds,
                headers: {
                    "Authorization": "Bearer " + loginState.token
                },
                //signal: currentController.signal
            }).then((response) => {
                //console.log(response);



                if (response != null) {
                    //console.log(response);
                    //console.log(JSON.parse(response));
                    var statusCode = response.status;
                    //console.log(statusCode);
                    if (statusCode != 1) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length > 0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }
                    else {
                        var data = response.data.solrResult;
                        //console.log(data);

                        var numFound = data.response.numFound;

                        //console.log(numFound);
                        if (fromSearchBar == true) {

                            setShowSearchResults(true);
                            setResultsData(data);
                            //setShowDropdown(false);

                            setResultTerm(search);

                        }
                        else {
                            setResultsData(data);
                            //setShowDropdown(true);
                            if (numFound != null && numFound > 0) {
                                //setDisplayDrop(true);
                            }
                            else {
                                //setDisplayDrop(false);
                            }

                        }
                        setRecordsTotal(numFound);
                        setRangeEnd(end);
                    }

                }
                else {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                setIsLoading(false);
            }).catch(function (error) {
                //console.log(error);
                if (axios.isCancel(error)) {
                    //console.log('Search request canceled:', error.message);
                }
                else {
                    console.error('Search error:', error);
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        },
                        error: error
                    });
                }
            });
            return res;
        }
    };

    const handlePageChange = (page) => {
        //console.log("handlePageChange", page);

        let index = 5 * (page - 1)
        //console.log(index);
        setCurrentPage(Math.ceil(page));
        setRangeStart(index);
        setRangeEnd(index + 10 >= recordsTotal ? recordsTotal : index + 10);
        getSearchData(resultTerm, true, index, exactMatchFlag);

    };
    //parse(highlightData[doc.id]['text'][0])

    const loadMoreData = () => {
        var index = rangeEnd + 10;
        var end = index >= recordsTotal ? recordsTotal : index;
        //setRangeStart(index);
        //setRangeEnd(index >= recordsTotal ? recordsTotal : index);
        getSearchData(resultTerm, false, end, exactMatchFlag);

    };

    {/*
        function getHiglightDescription(documentId, highLightList) {    
            let returnValue = '';

            let debugInfo = 'documentId: [' + documentId + '] \n';
            var hightLightDetails = highLightList[documentId];
        
            if (hightLightDetails != null) {
                let title = hightLightDetails.title;
                let subject = hightLightDetails.subject;
                let text = hightLightDetails.text;
                
                if (subject != null && subject.length > 0) {
                    returnValue = subject[0];
                    debugInfo += 'highlighting by subject.'; 
                } else if (title != null && title.length > 0) {
                    returnValue = title[0];
                    debugInfo += 'highlighting by title.'; 
                } else if (text != null && text.length > 0) {
                    returnValue = text[0];
                    debugInfo += 'highlighting by text.'; 
                } else {
                    debugInfo += 'no highlighting found.'; 
                }
            }
            
            if (debugMode) {
                //console.log(debugInfo + ' highlighting value: ' + returnValue);
            }
            return returnValue;
        }
    */}
    const getHiglightDescription = (data, docData, docId) => {
        var desc = "";

        if (data != null && Object.keys(data).length > 0) {
            let title = data.title;
            let subject = data.subject;
            let text = data.text;

            if (subject != null && subject.length > 0) {
                desc = subject[0];
            } else if (title != null && title.length > 0) {
                desc = title[0];
            } else if (text != null && text.length > 0) {
                desc = text[0];
            } else {

            }
        } else {
            // if highlight data is null, return the doc subject
            if (docData != null && docData.length > 0) {
                //find the doc by id
                let doc = docData.find(d => d.id == docId);
                if (doc.subject != null && doc.subject.length > 0) {
                    desc = doc.subject[0];
                }
            }
        }
        return desc;

        //resultsData['highlighting'][doc.id].hasOwnProperty('text') ? parse(resultsData['highlighting'][doc.id]['text'][0])
    }

    // remove non-displayalbe code
    const removeNonPrintableASCII = (str) => {
        if (!str) return ''; // Handle null or empty input gracefully
        return str.replace(/[^ -~]+/g, '');
    }

    // Render Suggestion list Component
    /** Ex. suggestionData
     * 
     * [
        "collation",
        {
            "collationQuery": "hope\\ vein",
            "hits": 21,
            "misspellingsAndCorrections": [
                "hospe",
                "hope",
                "vesin",
                "vein"
            ]
        },
        ]
    */
    const RenderSuggession = ({ suggestionData }) => {
        //console.log("RenderSuggession", suggestionData);
        let suggestionList = [];
        // get collationQuery
        for (let i = 0; i < suggestionData?.length; i++) {
            if (i % 2 != 0) {
                let s = removeNonPrintableASCII(suggestionData[i].collationQuery).replace('\\', '');
                if (suggestionList.includes(s)) {
                    continue;
                }

                suggestionList.push(s);
            }
        }

        //render suggestion list
        return (
            <>
                {suggestionList != null && suggestionList.length > 0 ?
                    <div className='text-start mb-3 mt-4'>
                        <span className="me-2 suggestion-text">Did you mean:</span>
                        {
                            suggestionList != null && suggestionList.length > 0 ?
                                suggestionList.map((s, i) =>
                                    <TextButton
                                        className="text-decoration-none me-2" variant="link"
                                        content={
                                            <p className="mb-0 header4 semibold color-143F5F text-start">{s}</p>
                                        }
                                        onClick={() => {
                                            setShowSearchResults(false);
                                            getSearchData(s, true, 10, exactMatchFlag);
                                            ga_log_search(s);
                                            setResultTerm(s);
                                        }}>
                                    </TextButton>
                                )
                                : null
                        }
                    </div> : null}
            </>
        )
    }

    const NoSuggestionFound = ({ suggestionData }) => {

        //console.log("NoSuggestionFound", suggestionData);

        return (
            <>
                {suggestionData != null && suggestionData.length == 0 ?
                    <>
                        <div className='text-start suggestion-text'>
                            <p>We couldn't find anything matching your search. Try:</p>
                            <ul>
                                <li>Checking your spelling.</li>
                                <li>Using more general keywords.</li>
                                {curExactMatchFlag ? <li>Removing filters like "Exact matches only."</li> : null}
                            </ul>
                            <p>In the meantime, you may find these resources helpful:</p>
                        </div>
                        <Row lg={2} className="cta-cards col-gap-2 row-gap-3 pb-5">
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4 m-0 p-0 mt-3">
                                        <div className="align-items-center">
                                            <ManageAccountsOutlined fontSize="large"></ManageAccountsOutlined>
                                        </div>
                                        <div className="">
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold">Become a PSO</span></div>
                                            <div className="public-card-content d-flex flex-column align-items-start">
                                                <p className="text-start body regular suggestion-text">If your organization's primary mission and work focuses on improving patient safety and the quality of healthcare delivery, you may be eligible to become a PSO.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Become a PSO'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {/*<Col className="" lg={6}>
                                <Card className="h-100 border-0">
                                    <Card.Body  className="d-flex flex-column flex-md-row align-items-start gap-4">
                                        <div className="align-items-center">
                                            <QuestionAnswerOutlined fontSize="large"></QuestionAnswerOutlined>
                                            
                                        </div>
                                        <div>
                                            <p className="text-start mb-2"><span className="public-card-header horizontal  header2 bold">Commenting Tool</span></p>
                                            <div className="public-card-content  d-flex flex-column align-items-start">
                                                <p className="text-start body regular color-68727D ">We'd love your feedback on how to improve this Common Format.</p>
                                                <IconTextButton 
                                                    variant="clear" 
                                                    icon={ICONS.arrow} 
                                                    className="reverse p-0 " 
                                                    content="Learn More" 
                                                    onClick={() =>
                                                        navigate(PATHS.public['Current Common Formats'])
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>*/}
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4 m-0 p-0">
                                        <div className="align-items-center">
                                            <LocalHospitalOutlined fontSize="large"></LocalHospitalOutlined>
                                        </div>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Current Common Formats</span></div>
                                            <div className="public-card-content  d-flex flex-column align-items-start">
                                                <p className="text-start body regular suggestion-text">If you are looking for a standardized structure for patient safety event data, you might be looking for our Common Formats.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Current Common Formats'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4 m-0 p-0">
                                        <div className="align-items-center">
                                            <PersonalInjuryOutlined fontSize="large"></PersonalInjuryOutlined>
                                        </div>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Submit Data</span></div>
                                            <div className="public-card-content d-flex flex-column align-items-start">
                                                <p className="text-start body regular suggestion-text">By securely sharing your PSO's patient safety data with PSOPPC, you contribute to national learning that helps improve the quality of care.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Submit Data'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4 m-0 p-0">
                                        <div className="align-items-center">
                                            <DatasetOutlined fontSize="large"></DatasetOutlined>
                                        </div>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Learn from the Data</span></div>
                                            <div className="public-card-content d-flex flex-column align-items-start">
                                                <p className="text-start body regular suggestion-text">The Network of Patient Safety Databases (NPSD) team at AHRQ transforms your submitted, non-identifiable patient safety data into useful tools like dashboards and reports with clear, actionable information.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Learn from the Data'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                    : null}
            </>
        )
    }

    return (
        <ReCaptchaWrapper 
            action="search_landing"
            title="Search"
        >
            <>
            <Row className="m-0 p-0 g-0">
                <PageHeader
                    title="Search"
                    intro={null}
                    childrenRowCols={{
                        column: {
                            xs: 11,
                            sm: 11,
                            md: 11,
                            lg: 9,
                            xl: 8,
                            //xxl: 'auto'
                        }
                    }}
                >
                    {/* <Dropdown  
                        autoClose="outside"
                        show={displayDrop && showDropdown && recordsTotal>0} 
                        ref={dropdownRef}
                        className="search-div-dropdown" 
                        onToggle={(nextShow, meta)=> {
                            
                            //console.log(displayDrop); 
                            //console.log(nextShow); 
                            //console.log(meta);
                            if(meta.source == "keydown" && meta.originalEvent.key != "Enter"){

                            }
                            else{
                                const isChildInParent = dropdownRef.current.contains(meta.originalEvent.target);
                                //console.log(isChildInParent);
                                setDisplayDrop(isChildInParent);
                            }
                            
                        }}
                        onBlur={(e)=> {
                            if(e.relatedTarget != null){

                                const isChildInParent = dropdownRef.current.contains(e.relatedTarget);
                                
                                //console.log(isChildInParent);
                                setDisplayDrop(isChildInParent);
                            }
                            else{

                            }
                            
                            //console.log(e);
                        }}
                    > */}
                    <Form as={Col} ref={formRef} className="search-form col-12">
                        <Form.Group id="" className="w-100 g-0 d-flex flex-column flex-wrap flex-sm-nowrap flex-sm-row">
                            <Col sm={8} md={9} lg={10} className="d-flex flex-row align-items-center g-0">
                                <SearchOutlined className="ms-3 search-icon position-absolute"></SearchOutlined>
                                <Dropdown.Toggle
                                    as={Form.Control}
                                    value={resultTerm}
                                    onChange={(e) => {
                                        var val = e.target.value;
                                        setResultTerm(val);
                                        if (val != null && val.trim() != '') {
                                            //getSearchData(val, false, 5);
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        //setDisplayDrop(true);
                                        if (e.key == "Enter") {
                                            var val = e.target.value;

                                            if (resultTerm != null && resultTerm.trim() != '') {
                                                setShowSearchResults(false);
                                                getSearchData(resultTerm, true, 10, exactMatchFlag);
                                                ga_log_search(resultTerm);
                                            }
                                            else {
                                                setShowSearchResults(false);
                                                //getSearchData(null, true, 10);
                                                //setShowSearchResults(true);
                                                setResultsData(null);
                                                setResultTerm(resultTerm);
                                                setRecordsTotal(0);
                                                setRangeEnd(0);
                                                setIsLoading(false);
                                            }
                                            //setShowSearchResults(true);
                                            //setShowDropdown(false);

                                            setResultTerm(resultTerm);
                                            //setResultsData(listData);

                                        }
                                        //const isChildInParent = dropdownRef.current.contains(meta.originalEvent.target);
                                        //console.log(isChildInParent);
                                        //setDisplayDrop(isChildInParent);
                                    }}
                                    /*
                                     onBlur={(e)=>{
                                         //console.log(e);
                                         
                                         if(e.relatedTarget != null){
                                             const isChildInForm = formRef.current.contains(e.relatedTarget);
                                             const isChildInParent = dropdownRef.current.contains(e.relatedTarget);
                                             
                                             //console.log(isChildInParent);
                                             //console.log(isChildInForm);
 
                                             if(isChildInParent==true || isChildInForm==true){
                                                 setShowDropdown(true);
                                             }
                                             else{
                                                 setShowDropdown(false);
                                             }
                                         }
                                         //if(e.)
                                     }}*/
                                    className="m-0 me-sm-2"
                                    id="searchField"
                                    role="searchbox"
                                    aria-label="Search Website"
                                    placeholder="Search PSOPPC..."
                                />
                            </Col>
                            <TextButton
                                //as={Col} 
                                //disabled={isLoading==true ? true : false}
                                variant="normal"
                                content={'Search Now'}
                                className="d-flex mt-3 mt-sm-0 justify-content-center w-sm-fit-content align-items-center col col-sm-4 col-md-3 col-lg-2"
                                onClick={() => {
                                    //console.log(resultTerm);
                                    if (resultTerm != null && resultTerm.trim() != '') {
                                        setShowSearchResults(false);
                                        getSearchData(resultTerm, true, 10, exactMatchFlag);
                                        ga_log_search(resultTerm);
                                    }
                                    else {
                                        setShowSearchResults(false);
                                        //getSearchData(null, true, 10);
                                        //setShowSearchResults(true);
                                        setResultsData(null);
                                        //console.log(resultTerm);
                                        setResultTerm(resultTerm);
                                        setRecordsTotal(0);
                                        setRangeEnd(0);
                                        setIsLoading(false);
                                    }
                                    //setShowSearchResults(true);
                                    //setShowDropdown(false);

                                    setResultTerm(resultTerm);
                                    //setResultsData(listData);

                                }} />
                        </Form.Group>
                        <Form.Group id="" className="w-100 d-flex">
                            <Form.Check
                                value={exactMatchFlag}
                                className="mt-3 text-start pb-3"
                                type={"checkbox"}
                                id={"exactMatchCheck"}
                                onChange={(e) => {
                                    setExactMatchFlag(e.target.checked);
                                }}
                                checked={exactMatchFlag}
                                label={
                                    <>
                                        <span>
                                            Exact matches only&nbsp;
                                        </span>
                                    </>}
                            />
                            <span className='mt-3'><ExactMatchOverLay></ExactMatchOverLay></span>
                        </Form.Group>
                    </Form>
                    {/* <Dropdown.Menu className="g-0 search-dropdown mt-3  col-12" >
                                        <Dropdown.ItemText className="text-start body semibold ps-0 mb-3">Suggested</Dropdown.ItemText>
                                        <Col className="d-flex flex-column results-box gap-2 align-items-start">
                                        {   listData != null && showDropdown==true
                                            ? 
                                                <>
                                                {listData.response.docs.map(doc => {
                                                    //console.log(doc);
                                                    return (
                                                        
                                                        <Dropdown.ItemText as="div" className="ps-3 py-2">
                                                            <IconTextButton className="p-0 reverse" variant="clear" icon={getFileTypeIcon(doc.fileextension[0])} 
                                                                content={
                                                                    <p className="m-0 p-0 header4 semibold color-143F5F text-start">{doc.displayname}</p>
                                                                }
                                                                onClick={()=>downloadFile(doc.id)}
                                                            ></IconTextButton>
                                                        </Dropdown.ItemText>
                                                    );
                                                })}</>
                                            
                                            : null
                                        }
                                        </Col>
                                        
                                        <TextButton className="body mx-auto d-flex " variant="clear" content="See all results..." 
                                            onClick={()=>{
                                                setShowSearchResults(true);
                                                //setShowDropdown(false);

                                                setResultTerm(searchTerm);
                                                setResultsData(listData);
                                            }}
                                        ></TextButton>
                                       
                                        
                                    </Dropdown.Menu> */}
                    {/*</Dropdown>
                                <Col lg={8} className=" g-0 search-dropdown mt-3  col-xl-8 col-lg-9 col-md-11 col-sm-9 col-11">
                               
                                    <p className="text-start body semibold">Suggested</p>
                                    <Col className="d-flex flex-column results-box gap-2 align-items-start">
                                            
                                        {
                                            listData.response.docs.map(doc => {
                                                //console.log(doc);
                                                return (
                                                    <div className="ps-3 py-2">
                                                        <IconTextButton className="p-0 reverse" variant="clear" icon={getFileTypeIcon(doc.fileextension[0])} 
                                                            content={
                                                                <p className="m-0 p-0 header4 semibold color-143F5F text-start">{doc.displayname}</p>
                                                            }
                                                        ></IconTextButton>
                                                        
                                                    </div>
                                                );
                                            })
                                        }
                                                
                                    </Col>
                                
                            
                                    <TextButton className="body mx-3 mt-4" variant="clear" content="See all results..." 
                                        onClick={()=>{
                                            setShowSearchResults(true);
                                            setShowDropdown(false);

                                            setResultTerm(searchTerm);
                                            setResultsData(listData);
                                        }}
                                    ></TextButton>
                                </Col> */}

                </PageHeader>
                {isLoading == true
                    ? <Col className="pb-2  mb-0 ms-auto me-auto d-flex justify-content-center" xs={11} sm={9} md={11} lg={10} xl="10" >
                        <Spinner variant="table-load-spinner" size="lg" animation="border" className="justify-self-center align-self-center m-5" />
                    </Col>
                    :
                    recordsTotal > 0 || showSearchResults == false
                        ? null
                        :
                        <>
                            <Col lg={2}></Col>
                            <Col sm={12} md={11} lg={10} className='p-md-0 px-3 mx-auto'>
                                <RenderSuggession suggestionData={resultsData?.spellcheck?.collations}></RenderSuggession>
                                <p className="text-center text-md-start body normal searchCount w-100">No Results Found.</p>
                                <NoSuggestionFound suggestionData={resultsData?.spellcheck?.collations}></NoSuggestionFound>
                            </Col>
                        </>
                }
                {
                    showSearchResults == true && resultsData != null && recordsTotal > 0
                        ?
                        <Col sm={12} md={11} lg={10} className="d-flex flex-column g-0 mx-auto search-results-col px-3 mb-4">
                            <p className="text-center text-md-start body normal searchCount w-100">{resultsData.response.numFound} results found in {resultsData.responseHeader.QTime / 1000} seconds</p>
                            <InfiniteScroll
                                scrollThreshold={0.8}
                                dataLength={rangeEnd}
                                next={loadMoreData}
                                hasMore={resultsData.response.numFound > rangeEnd}
                                loader={
                                    <Spinner variant="table-load-spinner" size="lg" animation="border" className="justify-self-center align-self-center m-5" />
                                }
                            >
                                <Col className="d-flex flex-column results-box gap-4 align-items-start">
                                    {
                                        resultsData.response.docs.map((doc, index) => {
                                            return (
                                                <Col xs={12} className="search-list-item d-flex flex-column flex-md-row gap-3 gap-md-4">
                                                    <Col xs={12} md={4} xl={3} className="d-flex flex-column  align-items-start gap-3 gap-md-3">
                                                        <div className="d-flex flex-column flex-md-row w-100">
                                                            <span className="mb-0 mb-2 mb-md-0 header4 regular text-black text-decoration-none me-md-2">{index + 1}. </span>
                                                            <TextButton
                                                                className="text-decoration-none" variant="link"
                                                                content={
                                                                    // <p className="mb-0 header4 semibold color-143F5F text-center text-md-start ">{doc.displayname}</p>
                                                                    <p className="mb-0 header4 semibold color-143F5F text-start ">{doc.displayname}</p>
                                                                }
                                                                //onClick={() => downloadFile(doc.id)}
                                                                groupId={doc.id}
                                                            >
                                                            </TextButton>
                                                        </div>
                                                        {/*<p className="header4 semibold color-143F5F text-center text-md-start ">{doc.displayname}</p> */}
                                                        <IconTextButton className="clear-button-padding" variant="clear-download" icon={getFileTypeIcon(doc.fileextension[0])}
                                                            content={
                                                                <p className="m-0 p-0 bodyS semibold text-start">Download {doc.fileextension[0].toUpperCase()}</p>
                                                            }
                                                            groupId={doc.id}
                                                            // onClick={() => downloadFile(doc.id)}
                                                        ></IconTextButton>

                                                    </Col>
                                                    <Col className="d-flex align-items-start">

                                                        <div className="body ">{parse(getHiglightDescription(resultsData['highlighting'][doc.id], resultsData['response']?.docs, doc.id))}</div>
                                                    </Col>
                                                </Col>
                                            );
                                        })
                                    }
                                </Col>
                            </InfiniteScroll>
                            {/*<DatatablePagination 
                                totalEntries={resultsData.response.numFound}
                                rangeStart={rangeStart+1}
                                rangeEnd={rangeEnd}
                                currentPage={currentPage}
                                numPages={Math.ceil(resultsData.response.numFound/5)}
                                handlePageChange={handlePageChange}
                            ></DatatablePagination>*/}
                        </Col >
                        :
                        null
                }
            </Row >
            {showSearchResults == true || isLoading == true
                ? null
                :
                <>
                    <Col className="pb-2  mb-0 ms-auto me-auto d-flex " xs={11} sm={9} md={11} lg={10} xl="10" >
                        <Row lg={2} className="cta-cards col-gap-2 row-gap-3 pt-5 mt-3 pb-5 justify-content-center">
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                        <div className="align-items-center">
                                            <ManageAccountsOutlined fontSize="large"></ManageAccountsOutlined>
                                        </div>
                                        <div className="">
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold">Become a PSO</span></div>
                                            <div className="public-card-content d-flex flex-column align-items-start">
                                                <p className="text-start body regular color-32363E">If your organization's primary mission and work focuses on improving patient safety and the quality of healthcare delivery, you may be eligible to become a PSO.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Become a PSO'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {/*<Col className="" lg={6}>
                                <Card className="h-100 border-0">
                                    <Card.Body  className="d-flex flex-column flex-md-row align-items-start gap-4">
                                        <div className="align-items-center">
                                            <QuestionAnswerOutlined fontSize="large"></QuestionAnswerOutlined>
                                            
                                        </div>
                                        <div>
                                            <p className="text-start mb-2"><span className="public-card-header horizontal  header2 bold">Commenting Tool</span></p>
                                            <div className="public-card-content  d-flex flex-column align-items-start">
                                                <p className="text-start body regular color-68727D ">We'd love your feedback on how to improve this Common Format.</p>
                                                <IconTextButton 
                                                    variant="clear" 
                                                    icon={ICONS.arrow} 
                                                    className="reverse p-0 " 
                                                    content="Learn More" 
                                                    onClick={() =>
                                                        navigate(PATHS.public['Current Common Formats'])
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>*/}
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                        <div className="align-items-center">
                                            <LocalHospitalOutlined fontSize="large"></LocalHospitalOutlined>
                                        </div>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Current Common Formats</span></div>
                                            <div className="public-card-content  d-flex flex-column align-items-start">
                                                <p className="text-start body regular color-32363E">If you are looking for a standardized structure for patient safety event data, you might be looking for our Common Formats.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Current Common Formats'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                        <div className="align-items-center">
                                            <PersonalInjuryOutlined fontSize="large"></PersonalInjuryOutlined>
                                        </div>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Submit Data</span></div>
                                            <div className="public-card-content d-flex flex-column align-items-start">
                                                <p className="text-start body regular color-32363E">By securely sharing your PSO's patient safety data with PSOPPC, you contribute to national learning that helps improve the quality of care.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Submit Data'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col className="" lg={10}>
                                <Card className="h-100 border-0">
                                    <Card.Body className="d-flex flex-column flex-md-row align-items-start gap-4">
                                        <div className="align-items-center">
                                            <DatasetOutlined fontSize="large"></DatasetOutlined>
                                        </div>
                                        <div>
                                            <div className="text-start mb-2"><span className="public-card-header horizontal  header2 bold ">Learn from the Data</span></div>
                                            <div className="public-card-content d-flex flex-column align-items-start">
                                                <p className="text-start body regular color-32363E">The Network of Patient Safety Databases (NPSD) team at AHRQ transforms your submitted, non-identifiable patient safety data into useful tools like dashboards and reports with clear, actionable information.</p>
                                                <IconTextButton
                                                    variant="clear"
                                                    icon={ICONS.arrow}
                                                    className="reverse p-0 "
                                                    content="Learn More"
                                                    onClick={() =>
                                                        navigate(PATHS.public['Learn from the Data'])
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    {/*<Row className="faq m-0 d-flex justify-content-center">
                        <Col lg="10">
                            <h2 className="mb-5">Frequently Asked Questions</h2>
                            <PublicAccordion
                                defaultActiveKey={[]}
                                accordionItemsContent={[
                                    {
                                        header: "What are the password requirements for the PSOPPC Profile?",
                                        content: ()=>{
                                            return (
                                                <>
                                                    <p className="mb-0">Contains 16-24 characters</p>
                                                    <p className="mb-0">Contains three of the four character types:</p>
                                                    <ul className="mb-0 ps-0">
                                                        <li>- Uppercase character</li>
                                                        <li>- Lowercase character Number</li>
                                                        <li>- Valid Special characters: ! @ # $ % & * ( ) _ = +</li>
                                                        <li>- [ ] ?</li>
                                                    </ul>
                                                    
                                                    <p className="mb-0">Does not contain the User ID, First Name, Last Name</p>
                                                    <p className="mb-0">Can be only changed once in a 24-hour period</p>
                                                </>
                                            )
                                        }
                                    },
                                    {
                                        header: "Why is submitting my PSO Profile important?",
                                        content: ()=>{
                                            return (
                                                <>
                                                    <p className="mb-0">
                                                        Federally-listed Patient Safety Organizations (PSOs) are strongly encouraged by the Agency for Healthcare Research and Quality (AHRQ) to complete the PSO Profile annually. PSO Profile data assists various agencies in conveying vital attributes of PSOs and the providers they serve. For example, the Department of Health and Human Services (HHS) uses aggregate statistics from the PSO Profile submissions to administer the Patient Safety and Quality Improvement Act (PSQIA) and report on the reach and focus of PSOs. To assist providers in choosing a PSO, AHRQ uses the PSO Profile information to populate the PSO Selection Tool on <a href="https://pso.ahrq.gov/listed">http://pso.ahrq.gov/listed</a>.
                                                    </p>
                                                </>
                                            )
                                        }
                                    },
                                    {
                                        header: "How do I count the providers my PSO serves for my PSO profile?",
                                        content: ()=>{
                                            return (
                                                <>
                                                    <p className="mb-0">
                                                        Take a look at our guidelines on <DownloadLink groupId={2062} linktext={"Provider counts in the PSO Profile"}></DownloadLink>.
                                                    </p>
                                                </>
                                            )
                                        }
                                    }
                                ]}
                            ></PublicAccordion>

                        </Col>
                    </Row>*/}
                </>
            }
        </>
        </ReCaptchaWrapper>
    );
}

export default Search;
